import numeral from 'numeral';
import 'numeral/locales/et';


export function truncfloatformat(number) {
    numeral.locale('et');
    return numeral(parseFloat(number)).format('0.[000]');
}
